/**
 * useDetachDomain hook
 *
 * TanStack mutation wrapping `domainsApi.detachDomain`. Takes both
 * `domainId` and `siteId` so we can invalidate the affected site's detail
 * key in addition to the shared `['domains']` and `['sites']` lists.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { domainsApi } from '@/api/domainsApi';

interface DetachInput {
  domainId: string;
  siteId: string;
}

export function useDetachDomain() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: DetachInput) => domainsApi.detachDomain(input.domainId),
    onSuccess: (_, { siteId }) => {
      queryClient.invalidateQueries({ queryKey: ['domains'] });
      queryClient.invalidateQueries({ queryKey: ['sites', siteId] });
      queryClient.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}
